import React, {useContext} from 'react';
import b_ from 'b_';

import {useUser} from 'client/common/contexts/user';
import ListModeContext from 'client/common/contexts/list-mode';

import EmptyState from './empty-state';
import {FilledState} from './filled-state';

import './survey-list.css';

const b = b_.with('survey-list');

export default function SurveyList() {
    const user = useUser();
    const userHasSurveys = user?.info?.hasSurveys ?? false;

    const listMode = useContext(ListModeContext);

    return (
        <div className={b({mode: listMode})}>
            {userHasSurveys ? <FilledState /> : <EmptyState />}
        </div>
    );
}
